import type { ReactElement } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { FiltersChip } from "app/pages/sales-intelligence/common-components/filters-panel";
import getUpdateDateOptionLabel from "app/pages/sales-intelligence/modules/find-apps-filters/components/filters/UpdateDateFilter/utils/getUpdateDateOptionLabel";
import type { IAppsUpdateDateFilterDto } from "app/pages/sales-intelligence/store/find-apps/types/commonFilters.dto";

const UpdateDateFilterResult = ({
    value,
    onFilterUpdate,
}: IFilterViewBaseModelProps<IAppsUpdateDateFilterDto>): ReactElement | null => {
    if (!value?.range || !value?.rangeType) {
        return null;
    }

    return (
        <Flex>
            <FiltersChip
                text={`${getUpdateDateOptionLabel(value?.rangeType)} ${getUpdateDateOptionLabel(value?.range, true)}`}
                onClose={() => onFilterUpdate()}
            />
        </Flex>
    );
};

export default UpdateDateFilterResult;
